import { Component, Input } from '@angular/core';
import { NgForm }           from '@angular/forms';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'wor-product-group-quick-add',
  template: require('./product-group.quick-add.component.html')
})
export class ProductGroupQuickAddComponent {
  @Input() categories : any[] = [];

  group : any = {};

  constructor (
    public activeModal                                                   : NgbActiveModal,
    private apiService             : ApiService,
    private messagesService   : MessagesService,
    private translateService                                             : TranslateService
  ) {}

  save ( form : NgForm ) : void {
    if (form.invalid) return;

    this.apiService.post('/product_groups', this.group, 'product_group')
    .then(group => {
      this.messagesService.show(
        this.translateService.instant('JS_SPACE.MESSAGES.CREATED.PRODUCT_GROUP_ADDED'),
        'success'
      );
      this.activeModal.close(group);
    })
    .catch(err => this.messagesService.error(err));
  }
}
